import { createContext } from "react";
import { AttachmentsIndexContextValue } from "./types";

/* ===========================================================================
 * CONTEXT: AttachmentsIndexContext
 * ===========================================================================
 */

/**
 * React Context for managing the Attachments index state.
 *
 * Provides:
 * - The list of attachments
 * - Loading state
 * - Modal configuration
 * - Optional callback handler
 *
 * Must be consumed within an AttachmentIndexProvider.
 */
export const AttachmentsIndexContext = createContext<
  AttachmentsIndexContextValue | undefined
>(undefined);
